let startX;
let scrollLeft;
let isDown = false
function cusorGrabingMousedown(slider, e){
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
}

function cusorGrabingMouseleave(slider, e){
  isDown = false;
  slider.classList.remove('active');
}

function cusorGrabingMouseup(slider, e){
  isDown = false;
  slider.classList.remove('active');
}

function cusorGrabingMousemove(slider, e){
  if(!isDown) {return};
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 1; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
}